// INFO: 특정 사이의 값으로 고정(VALUE가 튀어나가지 않도록 함)
export const clamp = (v, min, max) => Math.min(Math.max(v, min), max)
